import styled, { css } from 'styled-components'
import { tokens } from '@arvoreeducacao/bonsai-ds'
import {
  AudiobookIcon,
  CoverDescription
} from '@arvoreeducacao/bonsai-ds/dist/components/lib/cover/cover-content/CoverContent.styles'

const revealedCoverDescription = css`
  transition: ${tokens.transitions.default};
  opacity: 1;
  width: 100%;
  max-height: 300px;

  @media (max-width: ${tokens.sizes.mdScreen}px) {
    display: none;
  }
`

export const revealCoverOnFocus = css`
  &:focus-visible ${CoverDescription} {
    ${revealedCoverDescription}
  }

  &:has(:focus-visible) ${CoverDescription} {
    ${revealedCoverDescription}
  }
`

const a11yAudiobookBadge = css`
  ${AudiobookIcon} {
    color: ${tokens.colors.dark6};
    background-color: ${tokens.colors.secondaryLight};
    border-color: ${tokens.colors.secondaryDark};
  }
`

export const CoverRoot = styled.div<{ $a11yEnabled?: boolean }>`
  position: relative;

  ${revealCoverOnFocus}

  ${({ $a11yEnabled }) => ($a11yEnabled ? a11yAudiobookBadge : '')}
`

export const CoverActivationTarget = styled.button`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  border: none;
  background: none;
  pointer-events: none;
  border-radius: ${tokens.radius.medium};

  &:focus-visible {
    outline: 2px solid ${tokens.colors.dark6};
    outline-offset: 2px;
  }
`
